export const fnOrUndef = (condition, fn) => (condition ? fn : undefined);

export const delayCall = (fn, delay = 1000) => {
  const timeoutId = setTimeout(fn, delay);
  const cancel = () => clearTimeout(timeoutId);
  return cancel;
};

export const debounce = (fn, delay = 1000) => {
  let timeout;

  return function executedFunction(...args) {
    clearTimeout(timeout);
    timeout = setTimeout(() => {
      fn(...args);
    }, delay);
  };
};
